/**
 * Created by PanJiaChen on 16/11/18.
 */

import { kebabCase } from 'lodash'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * @description: 转换为rem尺寸
 * @param {*} val
 * @return {*}
 */
export function pxToRem(val, base = 16) {
  if (/^\d+(\.\d+)?(em|rem|%)$/.test(val)) {
    return val
  } else {
    const n = parseInt(val)
    if (isNaN(n)) {
      return ''
    } else {
      return n / base + 'rem'
    }
  }
}

/**
 * @description: 样式对象转换为字符串
 * @param {*} cssObj
 * @return {*}
 */
export function styleFromObject(cssObj) {
  let styleStr = ''
  if (cssObj && Object.prototype.toString.call(cssObj) === '[object Object]') {
    for (const key in cssObj) {
      if (Object.hasOwnProperty.call(cssObj, key)) {
        const val = cssObj[key] || ''
        styleStr += `${kebabCase(key)}:${val};`
      }
    }
  }
  return styleStr
}

/**
 * @description: 转化高度值
 * @param {*} height
 */
export function parseHeight(height) {
  if (typeof height === 'number') {
    return height
  }
  if (typeof height === 'string') {
    if (/^\d+(?:px)?$/.test(height)) {
      return parseInt(height, 10)
    } else {
      return height
    }
  }
  return null
}

/**
 * 检查表单内容是否改变
 * @param {Object} init 原始比较的对象
 * @param {Object} current 当前比较的对象
 * @returns {boolean}
 */
export function compareForm(init, current) {
  if (typeof current !== typeof init) {
    return true
  }
  if (Array.isArray(current)) {
    if (current.length !== init.length) {
      return true
    }
    for (let i = 0; i < current.length; i++) {
      if (compareForm(current[i], init[i])) {
        return true
      }
    }
  } else if (typeof current === 'object') {
    for (const key in current) {
      if (compareForm(current[key], init[key])) {
        return true
      }
    }
  } else {
    if (current !== init) {
      return true
    }
  }
  return false
}

/**
 * 将预留字段数据设置到表单中
 * @param {Object} instance 表单实例
 * @param {Object} form 表单数据
 * @param {Array} list 预留字段接口返回的数据
 * @param {string} formType 表单类型，默认为search search为搜索表单，update为添加、编辑表单
*/
export function setReserveFieldsIntoForm(instance, form, list, formType = 'search') {
  if (instance && form && Array.isArray(list)) {
    // type: 1:输入框 2:单选 3:多选 4:下拉 5:文字 6:多行文本框
    // value_type: 1:字符串 2:纯数字 3:金额 4:时间戳 5:浮点型
    list.forEach(item => {
      if (item.type === 1) {
        if (formType === 'search') {
          if (item.value_type !== 1) {
            instance.$set(form, item.mod_field, [])
          } else {
            instance.$set(form, item.mod_field, '')
          }
        } else {
          instance.$set(form, item.mod_field, '')
        }
      } else if (item.type === 3) {
        instance.$set(form, item.mod_field, [])
      } else if (item.type === 5) {
        instance.$set(form, item.mod_field, item.opt_value)
      } else {
        instance.$set(form, item.mod_field, '')
      }
    })
  }
}

/**
 * 格式化预留字段数据
 * @param {Array} list 预留字段接口返回的数据
 * @returns {Array}
 * @param {string} formType 表单类型，默认为search search为搜索表单，update为添加、编辑表单
*/
export function formatReserveFields(list = [], formType = 'search') {
  const result = []
  let config = {}
  if (!Array.isArray(list)) {
    return []
  }
  list.forEach(item => {
    // type: 1:输入框 2:单选 3:多选 4:下拉 5:文字 6:多行文本框
    // value_type: 1:字符串 2:纯数字 3:金额 4:时间戳 5:浮点型
    switch (item.type) {
      case 1:
        config = {
          prop: item.mod_field,
          label: `${item.title}：`,
          component: {
            name: 'el-input',
            attrs: {
              placeholder: '请输入'
            }
          }
        }
        if (formType === 'search') {
          if (item.value_type === 2 || item.value_type === 3 || item.value_type === 5) {
            config = {
              prop: item.mod_field,
              label: `${item.title}：`,
              component: {
                name: 'base-input-range'
              }
            }
          }
          if (item.value_type === 4) {
            config = {
              prop: item.mod_field,
              label: `${item.title}：`,
              component: {
                name: 'el-date-picker',
                attrs: {
                  'value-format': 'yyyy-MM-dd',
                  type: 'daterange',
                  'range-separator': '至',
                  'start-placeholder': '开始日期',
                  'end-placeholder': '结束日期'
                }
              }
            }
          }
        } else {
          if (item.value_type === 4) {
            config = {
              prop: item.mod_field,
              label: `${item.title}：`,
              component: {
                name: 'el-date-picker',
                attrs: {
                  'value-format': 'yyyy-MM-dd',
                  type: 'date',
                  placeholder: '请选择日期'
                }
              }
            }
          }
        }
        result.push(config)
        break
      case 2:
        config = {
          prop: item.mod_field,
          label: `${item.title}：`,
          component: {
            name: 'base-radio-group',
            attrs: {
              options: item.opt_value
            }
          }
        }
        result.push(config)
        break
      case 3:
        config = {
          prop: item.mod_field,
          label: `${item.title}：`,
          component: {
            name: 'base-checkbox-group',
            attrs: {
              options: item.opt_value
            }
          }
        }
        result.push(config)
        break
      case 4:
        config = {
          prop: item.mod_field,
          label: `${item.title}：`,
          component: {
            name: 'el-select',
            options: item.opt_value,
            optionsProp: {
              value: 'value',
              label: 'key'
            },
            attrs: {
              placeholder: `请选择${item.title}`
            }
          }
        }
        result.push(config)
        break
      case 5:
        config = {
          prop: item.mod_field,
          label: `${item.title}：`,
          component: {
            name: 'base-title',
            attrs: {
              title: item.opt_value,
              size: 'small',
              lineHeight: '36px'
            }
          }
        }
        result.push(config)
        break
      case 6:
        config = {
          prop: item.mod_field,
          label: `${item.title}：`,
          component: {
            name: 'el-input',
            attrs: {
              type: 'textarea',
              autosize: {
                minRows: 2,
                maxRows: 2
              },
              placeholder: '请输入'
            }
          },
          span: 24
        }
        result.push(config)
        break
    }
  })
  return result
}
